import { render, staticRenderFns } from "./QueryDatabase.vue?vue&type=template&id=1134f102&scoped=true&"
import script from "./QueryDatabase.vue?vue&type=script&lang=js&"
export * from "./QueryDatabase.vue?vue&type=script&lang=js&"
import style0 from "./QueryDatabase.vue?vue&type=style&index=0&id=1134f102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134f102",
  null
  
)

export default component.exports